import {
  OUR_EXCLUSIVES_FACET,
  USF_PROGRAMS_FACET,
} from '../constants/new-search-constants';

type TopSectionMapConfigKey =
  | typeof USF_PROGRAMS_FACET
  | typeof OUR_EXCLUSIVES_FACET;
export type TopSectionMapConfig = {
  [key in TopSectionMapConfigKey]: {
    facetLabel: string;
    facetValue: string;
    topSectionValue: string;
  };
};
export const topSectionMapConfig: TopSectionMapConfig = {
  [USF_PROGRAMS_FACET]: {
    facetLabel: USF_PROGRAMS_FACET,
    facetValue: 'Serve You',
    topSectionValue: 'serveyou',
  },
  [OUR_EXCLUSIVES_FACET]: {
    facetLabel: OUR_EXCLUSIVES_FACET,
    facetValue: 'All scoop',
    topSectionValue: 'allscoopproducts',
  },
};
export const mapFacets = (facetInput: string): Map<string, string[]> => {
  if (facetInput) {
    return new Map(
      facetInput.split(',').map(facetLabel => {
        const [key, value] = facetLabel?.split(':');
        return [key, value?.split('+')];
      }),
    );
  }
  return null;
};

export const topSectionFacetValueExist = (
  facetMap: Map<string, string[]>,
  facetKey: string,
) => {
  const facet = topSectionMapConfig[facetKey];
  return facetMap.get(facet.facetLabel)?.includes(facet.facetValue);
};
export const getFirstKey = (
  map: Map<string, string[]>,
  firstKey = USF_PROGRAMS_FACET,
  secondKey = OUR_EXCLUSIVES_FACET,
) => {
  const keys = Array.from(map.keys());
  return keys.indexOf(firstKey) < keys.indexOf(secondKey)
    ? firstKey
    : secondKey;
};
